module.exports = __webpack_public_path__ + "img/205-Gris Léger Structuré.jpg";